<!-- Proforma Two Preview Modal -->
<div class="modal fade" id="kt_modal_proforma_two_preview" tabindex="-1" aria-hidden="true">
  <div class="modal-dialog modal-xl">
    <div class="modal-content position-relative">
      <!-- Loading Overlay -->
      <div *ngIf="isGeneratingPDF" class="pdf-loading-overlay position-absolute w-100 h-100 d-flex align-items-center justify-content-center" style="z-index: 9999; background-color: rgba(255, 255, 255, 0.95); top: 0; left: 0; border-radius: 0.5rem;">
        <div class="text-center">
          <div class="spinner-border text-primary mb-3" role="status" style="width: 3rem; height: 3rem;">
            <span class="visually-hidden">Loading...</span>
          </div>
          <h5 class="text-primary mb-2">Generating PDF...</h5>
          <p class="text-muted mb-0">Please wait while we create your proforma document</p>
        </div>
      </div>

      <!-- Modal Header -->
      <div class="modal-header pb-0 border-0 justify-content-between">
        <!-- Save Button -->
        <button type="button" [disabled]="isLoading" class="btn btn-success btn-sm" (click)="saveProformaData()">
          <i class="ki-duotone ki-check fs-2" *ngIf="!isLoading">
            <span class="path1"></span>
            <span class="path2"></span>
          </i>
          {{ isLoading ? 'Saving...' : 'Save' }}
        </button>

        <!-- Close Button -->
        <div class="btn btn-sm btn-icon btn-active-color-primary" data-bs-dismiss="modal">
          <i class="ki-duotone ki-cross fs-1">
            <span class="path1"></span>
            <span class="path2"></span>
          </i>
        </div>
      </div>

      <!-- Modal Body -->
      <div class="modal-body px-lg-10 pb-lg-10">
        <!-- Proforma Document -->
        <div id="proforma-two-document-content" class="proforma-document bg-white" style="font-family: Arial, sans-serif; font-size: 12px; line-height: 1.4;">

          <!-- Header Section -->
          <div class="d-flex justify-content-between align-items-start mb-4">
            <!-- Company Logo and Info -->
            <div class="d-flex align-items-center">
              <div class="company-logo me-4 bg-black">
                <img alt="Logo" src="/assets/media/logos/default-dark.svg" style="height: 80px; width: auto; max-width: 120px;">
              </div>
              <!-- <div>
                <h1 class="text-primary fw-bold mb-1" style="font-size: 32px; color: #4A90E2 !important;">Imperial</h1>
                <h1 class="text-primary fw-bold mb-1" style="font-size: 32px; color: #4A90E2 !important;">Solutions</h1>
                <p class="text-muted mb-0 fw-bold" style="font-size: 14px; letter-spacing: 2px;">PROSPERITY FOR ALL</p>
              </div> -->
            </div>

            <!-- Company Address -->
            <div class="text-end">
               <p class="mb-0 fw-bold">{{ settings?.company }}</p>
              <p class="mb-0">{{ settings?.city }}, {{ settings?.state }}, JAPAN</p>
              <p class="mb-0">PHONE: {{ settings?.telephone }} FAX: {{ settings?.fax }}</p>
              <p class="mb-0">E-MAIL: {{ settings?.email_1 }}</p>
              <p class="mb-0 fw-bold" style="font-size: 12px;">EXPORTER OF NEW & USED VEHICLES, TRUCKS AND HEAVY MACHINERIES</p>
            </div>
          </div>

          <!-- Proforma Invoice Title -->
          <div class="text-center mb-4">
            <h2 class="fw-bold text-decoration-underline" style="font-size: 18px; color: #000;">PROFORMA INVOICE</h2>
          </div>

          <!-- Main Content Table -->
          <table class="table table-bordered" style="border: 2px solid #000;">
            <tbody>
              <!-- First Row: Messers and Date/Invoice Info -->
              <tr>
                <td class="p-2" style="width: 15%; border-right: 1px solid #000; vertical-align: top;">
                  <p class="mb-0 fw-bold">CONSIGNEE</p>
                </td>
                <td class="p-2" style="width: 35%; border-right: 1px solid #000; vertical-align: top;">
                  <p class="mb-0">{{ selectedProforma?.buyer_consignee_name || 'MT ROSE, ST PATRICK' }}</p>
                  <p class="mb-0">{{ selectedProforma?.buyer_country || 'GRENADA' }}</p>
                </td>
                <td class="p-2" style="width: 15%; border-right: 1px solid #000; vertical-align: top;">
                  <p class="mb-0 fw-bold">DATE</p>
                  <p class="mb-0 fw-bold">INVOICE NO</p>
                </td>
                <td class="p-2" style="width: 35%; vertical-align: top;">
                  <p class="mb-0">{{ selectedProforma && selectedProforma.order_date ? formatDate(selectedProforma.order_date) : '2025-09-16' }}</p>
                  <p class="mb-0">{{ selectedProforma?.order_number || '19138' }}</p>
                  <p class="mb-0 fw-bold">SHIPPING MARKS & NUMBERS</p>
                </td>
              </tr>

              <!-- Second Row: Port Information -->
              <tr>
                <td class="p-2 fw-bold" style="border-right: 1px solid #000;">PORT OF SHIPMENT</td>
                <td class="p-2" style="border-right: 1px solid #000;">{{ selectedProforma?.from_port || 'Japan / Kobe' }}</td>
                <td class="p-2" style="border-right: 1px solid #000; border: 2px solid #000;">
                  <p class="mb-0 fw-bold text-center">FAX: +81-78-291-5374</p>
                  <p class="mb-0 fw-bold text-center">MADE IN JAPAN</p>
                </td>
                <td class="p-2" rowspan="4" style="vertical-align: top;">
                  <p class="mb-0 fw-bold">VALIDITY OF L/C</p>
                  <textarea
                    [(ngModel)]="validityOfLC"
                    class="form-control mt-2"
                    rows="2"
                    placeholder="Enter validity details..."
                    value="{{ selectedProforma?.validity_of_lc || '' }}"
                    style="border: 1px solid #000; font-size: 11px; resize: none;">
                    
                  </textarea>
                </td>
              </tr>

              <!-- Third Row: Port of Delivery -->
              <tr>
                <td class="p-2 fw-bold" style="border-right: 1px solid #000;">PORT OF DELIVERY</td>
                <td class="p-2" style="border-right: 1px solid #000;">{{ selectedProforma?.to_port || 'Grenada / St. Georges' }}</td>
                <td class="p-2" style="border-right: 1px solid #000;"></td>
              </tr>

              <!-- Fourth Row: Date of Shipment -->
              <tr>
                <td class="p-2 fw-bold" style="border-right: 1px solid #000;">DATE OF SHIPMENT</td>
                <td class="p-2" style="border-right: 1px solid #000;"></td>
                <td class="p-2" style="border-right: 1px solid #000;"></td>
              </tr>

              <!-- Fifth Row: Vessel Name -->
              <tr>
                <td class="p-2 fw-bold" style="border-right: 1px solid #000;">VESSEL NAME</td>
                <td class="p-2" style="border-right: 1px solid #000;"></td>
                <td class="p-2" style="border-right: 1px solid #000;"></td>
              </tr>

              <!-- Payment Terms Row -->
              <tr>
                <td class="p-2 fw-bold" style="border-right: 1px solid #000;">PAYMENT TERMS :</td>
                <td class="p-2" style="border-right: 1px solid #000;" colspan="3"></td>
              </tr>
            </tbody>
          </table>

          <!-- Vehicle Details Table -->
          <table class="table table-bordered mt-3" style="border: 2px solid #000;">
            <thead>
              <tr style="background-color: #f8f9fa;">
                <th class="p-2 text-center fw-bold" style="width: 20%; border-right: 1px solid #000;">MARKS & NUMBERS</th>
                <th class="p-2 text-center fw-bold" style="width: 35%; border-right: 1px solid #000;">DESCRIPTION</th>
                <th class="p-2 text-center fw-bold" style="width: 15%; border-right: 1px solid #000;">QUANTITY</th>
                <th class="p-2 text-center fw-bold" style="width: 15%; border-right: 1px solid #000;">UNIT PRICE (USD)</th>
                <th class="p-2 text-center fw-bold" style="width: 15%;">TOTAL AMOUNT (USD) C&F</th>
              </tr>
            </thead>
            <tbody>
              <!-- Loop through all vehicles -->
              <tr *ngFor="let vehicle of selectedProforma?.vehicles; let i = index; trackBy: trackByVehicleId">
                <td class="p-2" style="border-right: 1px solid #000; vertical-align: top;">
                  <p class="mb-0 fw-bold">FAX: +81-78-291-5374</p>
                  <p class="mb-0 fw-bold">MADE IN JAPAN</p>
                </td>
                <td class="p-2" style="border-right: 1px solid #000; vertical-align: top;">
                  <p class="mb-0"><span class="fw-bold">CHASSIS NO</span> {{ vehicle.chassis_no || 'FF21S-115945' }}</p>
                  <p class="mb-0"><span class="fw-bold">YEAR</span> {{ vehicle.year || '2016 / 7' }}</p>
                  <p class="mb-0"><span class="fw-bold">FUEL</span> {{ vehicle.fuel_type || 'GASOLINE/HYBRID' }}</p>
                  <p class="mb-0"><span class="fw-bold">MAKE</span> {{ vehicle.maker_name || 'SUZUKI' }}</p>
                  <p class="mb-0"><span class="fw-bold">MODEL</span> {{ vehicle.name || 'IGNIS' }}</p>
                  <p class="mb-0"><span class="fw-bold">STEERING</span> {{ vehicle.steering || 'RIGHT HAND' }}</p>
                </td>
                <td class="p-2 text-center" style="border-right: 1px solid #000; vertical-align: middle;">
                  <p class="mb-0 fw-bold">1 UNIT</p>
                </td>
                <td class="p-2 text-center" style="border-right: 1px solid #000; vertical-align: middle;">
                  <p class="mb-0">USD{{ getIndividualVehiclePrice(i) || '5,000' }}</p>
                </td>
                <td class="p-2 text-center" style="vertical-align: middle;">
                  <p class="mb-0">USD{{ getIndividualVehiclePrice(i) || '5,000' }}</p>
                </td>
              </tr>

              <!-- Show fallback data when no vehicles are available -->
              <tr *ngIf="getVehicleCount() === 0">
                <td class="p-2" style="border-right: 1px solid #000; vertical-align: top;">
                  <p class="mb-0 fw-bold">FAX: +81-78-291-5374</p>
                  <p class="mb-0 fw-bold">MADE IN JAPAN</p>
                </td>
                <td class="p-2" style="border-right: 1px solid #000; vertical-align: top;">
                  <p class="mb-0"><span class="fw-bold">CHASSIS NO</span> FF21S-115945</p>
                  <p class="mb-0"><span class="fw-bold">YEAR</span> 2016 / 7</p>
                  <p class="mb-0"><span class="fw-bold">FUEL</span> GASOLINE/HYBRID</p>
                  <p class="mb-0"><span class="fw-bold">MAKE</span> SUZUKI</p>
                  <p class="mb-0"><span class="fw-bold">MODEL</span> IGNIS</p>
                  <p class="mb-0"><span class="fw-bold">STEERING</span> RIGHT HAND</p>
                </td>
                <td class="p-2 text-center" style="border-right: 1px solid #000; vertical-align: middle;">
                  <p class="mb-0 fw-bold">1 UNIT</p>
                </td>
                <td class="p-2 text-center" style="border-right: 1px solid #000; vertical-align: middle;">
                  <p class="mb-0">USD5,000</p>
                </td>
                <td class="p-2 text-center" style="vertical-align: middle;">
                  <p class="mb-0">USD5,000</p>
                </td>
              </tr>

              <!-- Total Row -->
              <tr>
                <td class="p-2" style="border-right: 1px solid #000;"></td>
                <td class="p-2" style="border-right: 1px solid #000;"></td>
                <td class="p-2" style="border-right: 1px solid #000;"></td>
                <td class="p-2 text-center fw-bold" style="border-right: 1px solid #000;">Total</td>
                <td class="p-2 text-center fw-bold">{{ getTotalAmount() || '5,000' }}</td>
              </tr>
            </tbody>
          </table>

          <!-- Total C&F Price Section -->
          <table class="table table-bordered mt-3" style="border: 2px solid #000;">
            <tbody>
              <tr>
                <td class="p-2 fw-bold" style="width: 20%; border-right: 1px solid #000;">TOTAL C&F PRICE</td>
                <td class="p-2" style="width: 80%;"></td>
                <td class="p-2 text-center fw-bold" style="width: 15%;">USD{{ getTotalAmount() || '5,000' }}</td>
              </tr>
            </tbody>
          </table>

          <!-- Bank Details and Signature Section -->
          <div class="row mt-4">
            <div class="col-8">
              <div class="bank-details">
                <p class="mb-2 fw-bold">OUR BANK DETAILS</p>
                <table class="table-sm" style="font-size: 11px;">
                  <tr>
                    <td class="pe-3 fw-bold">BANK NAME</td>
                    <td>:</td>
                    <td class="ps-2">{{bank.name}}</td>
                  </tr>
                  <tr>
                    <td class="pe-3 fw-bold">BRANCH NAME</td>
                    <td>:</td>
                    <td class="ps-2">{{bank.branch_name}}</td>
                  </tr>
                  <tr>
                    <td class="pe-3 fw-bold">ACCOUNT NAME</td>
                    <td>:</td>
                    <td class="ps-2">{{settings.company}}</td>
                  </tr>
                  <tr>
                    <td class="pe-3 fw-bold">ACCOUNT NO</td>
                    <td>:</td>
                    <td class="ps-2">{{bank.account_number}}</td>
                  </tr>
                  <tr>
                    <td class="pe-3 fw-bold">SWIFT CODE</td>
                    <td>:</td>
                    <td class="ps-2">{{bank.swift_code}}</td>
                  </tr>
                  <tr>
                    <td class="pe-3 fw-bold">BANK ADDRESS</td>
                    <td>:</td>
                    <td class="ps-2">{{bank.beneficiary_address}}</td>
                  </tr>
                </table>
              </div>
            </div>
            <div class="col-4 text-end">
              <!-- Company Stamp/Seal Area -->
              <div class="d-flex justify-content-end mb-3">
                <div class="text-center" style="width: 150px;">
                  <div class="border border-2 p-3 mb-2" style="height: 80px; display: flex; align-items: center; justify-content: center;">
                    <span class="text-muted small">SUPREME<br>MOTORS</span>
                  </div>
                  <div class="signature-area text-center">
                    <p class="mb-0 fw-bold" style="font-family: cursive; font-size: 18px;">{{settings.company}}</p>
                    <p class="mb-0 fw-bold">D.S.SETHI</p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Signature Section -->
          <div class="mt-4">
            <p class="mb-0 fw-bold">YOUR SIGNATURE AND DATE</p>
            <div style="border-bottom: 1px solid #000; width: 300px; height: 40px; margin-top: 10px;"></div>
          </div>

        </div>
      </div>

      <!-- Modal Footer -->
      <div class="modal-footer">
        <button type="button" class="btn btn-light" data-bs-dismiss="modal">Close</button>
        <button type="button" class="btn btn-primary" (click)="printProforma()">
          <i class="ki-duotone ki-printer fs-2">
            <span class="path1"></span>
            <span class="path2"></span>
            <span class="path3"></span>
          </i>
          Print
        </button>
      </div>
    </div>
  </div>
</div>
